howspace.components.summary = (() => {
    'use strict';

    real.events.on('ai:summarize:widget:completed', (notification) => {
        if (notification.object.target_widget) {
            // Handle target widget.
            const widget = $('#widget-' + notification.object.target_widget.id);
            if (widget.length > 0) {
                howspace.aiGen.clearPromptTimeout(widget);
                howspace.components.summary.update(widget.find('.howspace-summary'), notification.object.text);
            }
        } else if (notification.object.process_id) {
            // Handle dedicated AI process.
            const modal = $('.ai-full-screen-modal[data-process-id="' + notification.object.process_id + '"]');
            if (modal.length > 0) {
                howspace.components.summary.update(modal.find('.howspace-summary'), notification.object.text);
                real.button.reset(modal.find('.ai-save-as-widget'));
            }
        }
    });

    real.events.on('ai:summarize:widget:failed', notification => {
        if (notification.object.target_widget) {
            // Handle target widget.
            const widget = $('#widget-' + notification.object.target_widget.id);
            if (widget.length > 0) {
                howspace.aiGen.clearPromptTimeout(widget);
                howspace.components.summary.update(widget.find('.howspace-summary'), notification.object.error, true);
            }
        } else if (notification.object.process_id) {
            // Handle dedicated AI process.
            const modal = $('.ai-full-screen-modal[data-process-id="' + notification.object.process_id + '"]');
            if (modal.length > 0) {
                howspace.components.summary.update(modal.find('.howspace-summary'), notification.object.error, true);
                real.button.loading(modal.find('.ai-save-as-widget'));
            }
        }
    });

    const updateText = (summary, content, text) => {
        const textElement = content.find('.summary-text');
        // If the translator is enabled and the target language is set, do not update the text immediately,
        // but request the translation instead and let the translator handle the update.
        if (
            howspace.components.translator.isEnabled() &&
            howspace.components.translator.getTargetLang() !== null &&
            textElement.length > 0 &&
            textElement.hasClass('translatable')
        ) {
            textElement.removeClass('translated');
            howspace.components.translator.init(textElement);
        } else {
            textElement.text(text);
        }
        summary.dataAndAttr('text', text);
    }

    return {
        update: (summary, text, isError = false) => {
            /**
             * There are three main states and transitions between them.
             * 1. If loader is visible: transition either to content or no content.
             * 2. If content visible: either transition to no content or just animate to new height.
             * 3. If no content is visible: either transition to content or do nothing.
             */

            const loader = summary.find('.howspace-loader');
            const noContent = summary.find('.summary-no-content');
            const content = summary.find('.summary-content');

            if (isError && text !== '') {
                noContent.html('<div class="alert alert-warning">' + DOMPurify.sanitize(text) + '</div>');
            } else if (!isError && text === '') {
                // Blank state: empty or not enough source content to summarize.
                noContent.text(howspace.translate('summary_no_content'));
            }

            if (loader.is(':visible')) {
                if (text === '' || isError) {
                    // Transition from loader to no content / error message.
                    new real.animator()
                        .setParentElement(summary)
                        .setHideElement(loader)
                        .onHideReady(() => {
                            noContent.removeClass('d-none');
                        })
                        .setShowElement(noContent)
                        .setAnimDuration(700)
                        .startAnimation();
                } else {
                    // Transition from loader to content.
                    updateText(summary, content, text);
                    new real.animator()
                        .setParentElement(summary)
                        .setHideElement(loader)
                        .onHideReady(() => {
                            content.removeClass('d-none').addClass('grid');
                        })
                        .setShowElement(content)
                        .setAnimDuration(700)
                        .startAnimation();
                }
                return;
            }

            if (content.is(':visible')) {
                if (text === '' || isError) {
                    // Transition from content to no content / error message.
                    new real.animator()
                        .setParentElement(summary)
                        .setHideElement(content)
                        .setShowElement(noContent)
                        .setAnimDuration(700)
                        .startAnimation();
                } else {
                    // Update the text and animate to new height.
                    const textElement = content.find('.summary-text');
                    const originalText = textElement.text();

                    updateText(summary, content, text);
                    const newHeight = textElement.outerHeight();

                    textElement.text(originalText);
                    textElement.css('overflow', 'hidden');
                    howspace.animate(textElement, {height: newHeight, opacity: 0}, 700, () => {
                        textElement.text(text);
                        howspace.animate(textElement, {opacity: 1}, 700, () => {
                            textElement.css({
                                height: '',
                                overflow: '',
                            });
                        });
                    });
                }
                return;
            }

            if (noContent.is(':visible') && text !== '' && !isError) {
                // Transition from no content / error message to content.
                updateText(summary, content, text);
                new real.animator()
                    .setParentElement(summary)
                    .setHideElement(noContent)
                    .setShowElement(content)
                    .setAnimDuration(700)
                    .startAnimation();
            }
        }
    };

})();
